import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.css']
})
export class QuizComponent implements OnInit {

  public speedShoes = [
    {
      name: "Saucony Kinvara",
      img: "assets/images/shoes/saucony-kinvara.jpg",
      weight: 7.8,
      heelStack: 23,
      forefootStack: 19,
      heelToToeDrop: 4   
    },
    {
      name: "Brooks Launch",
      img: "assets/images/shoes/brooks-launch.jpg",
      weight: 9.0,
      heelStack: 24.5,
      forefootStack: 14.5,
      heelToToeDrop: 10   
    },
    {
      name: "Altra Escalante",
      img: "assets/images/shoes/altra-escalante.jpg",
      weight: 8.5,
      heelStack: 24,
      forefootStack: 24,
      heelToToeDrop: 0   
    }
  ]

  public cushionShoes = [
    {
      name: "Saucony Triumph",
      img: "assets/images/shoes/saucony-triumph.jpg",
      weight: 11.1,
      heelStack: 32.5,
      forefootStack: 24.5,
      heelToToeDrop: 8   
    },
    {
      name: "Brooks Glycerin",
      img: "assets/images/shoes/brooks-glycerin.jpg",
      weight: 10.6,
      heelStack: 32,
      forefootStack: 22,
      heelToToeDrop: 10   
    },
    {
      name: "Altra Torin Plush",
      img: "assets/images/shoes/altra-torin-plush.jpg",
      weight: 9.6,
      heelStack: 26,
      forefootStack: 26,
      heelToToeDrop: 0   
    }
  ]

  public stabilityShoes = [
    {
      name: "Saucony Guide",
      img: "assets/images/shoes/saucony-guide.jpg",
      weight: 10.2,
      heelStack: 26,
      forefootStack: 18,
      heelToToeDrop: 8   
    },
    {
      name: "Brooks Adrenaline",
      img: "assets/images/shoes/brooks-adrenaline.jpg",
      weight: 10.0,
      heelStack: 28.5,
      forefootStack: 16.5,
      heelToToeDrop: 12   
    },
    {
      name: "Altra Provision",
      img: "assets/images/shoes/altra-provision.jpg",
      weight: 9.8,
      heelStack: 25,
      forefootStack: 25,
      heelToToeDrop: 0.0   
    }
  ]

  constructor() { }

  ngOnInit(): void {
    
  }

}
